import cn from "classnames";
import { Transition } from "components/shared/column";
import ImageGallery from "components/shared/imageGallery";
import { dateTimeToView } from "helpers/date";
import { platformNewsItemGradesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { viewContainer } from "helpers/redux";
import Tooltip from "rc-tooltip";
import React, { useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { getForView, markAsRead, setGrade } from "sources/books/platformNews";

function ShowNews(props) {
    const { match, location, history } = props;
    const { id } = match.params;
    const [loading, setLoading] = useState(true);
    const [gradeLoading, setGradeLoading] = useState(false);
    const [data, setData] = useState({});

    useEffect(() => {
        getForView(id).then((res) => {
            if (res) {
                setData(res);
            }
            setLoading(false);
        });
        markAsRead({ id });
    }, [id]);

    const setGradeForNewsItem = (grade) => {
        if (gradeLoading) {
            return;
        }
        setGradeLoading(true);
        let likeIteration = grade === platformNewsItemGradesEnum.Like ? 1 : -1;
        if (grade === data.selectedGrade) {
            likeIteration = -likeIteration;
            grade = platformNewsItemGradesEnum.None;
        }
        setData({ ...data, selectedGrade: grade, likeCount: data.likeCount + likeIteration });
        setGrade({ id, grade }).then(() => setGradeLoading(false));
    };

    return (
        <Transition dir="full" {...{ match, location, history }}>
            <div className="page-book__show book-show">
                <div className="book-show__head">
                    <div
                        className="book-show__close close close--sm"
                        onClick={() => history.push(`${paths.userPlatformNews}/list?tab=${data.section}`)}
                    />
                    <div className="book-show__title">{data.header}</div>
                    <div className="d-flex justify-content-between align-items-center">
                        <small className="text-muted font-italic mr-4">{dateTimeToView(data.createdAt)}</small>
                        <div className="btn-toolbar">
                            <div className="btn-group">
                                <Tooltip overlay="Нравится" placement="bottom">
                                    <button
                                        className={cn("btn px-4", {
                                            "btn-secondary": data.selectedGrade !== platformNewsItemGradesEnum.Like,
                                            "btn-dark": data.selectedGrade === platformNewsItemGradesEnum.Like,
                                        })}
                                        onClick={() => setGradeForNewsItem(platformNewsItemGradesEnum.Like)}
                                    >
                                        <i className="icon-uEAC8-thumbs-up inline-icon" />
                                        {data.likeCount > 0 && <b className="ml-2">{data.likeCount}</b>}
                                    </button>
                                </Tooltip>
                                {data.selectedGrade === platformNewsItemGradesEnum.None && (
                                    <div className="news-item__vertical-border" />
                                )}
                                <Tooltip overlay="Не нравится" placement="bottom">
                                    <button
                                        className={cn("btn px-4", {
                                            "btn-secondary": data.selectedGrade !== platformNewsItemGradesEnum.Dislike,
                                            "btn-dark": data.selectedGrade === platformNewsItemGradesEnum.Dislike,
                                        })}
                                        onClick={() => setGradeForNewsItem(platformNewsItemGradesEnum.Dislike)}
                                    >
                                        <i className="icon-uEAC9-thumbs-down inline-icon" />
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="book-show__body">
                    <div className={cn("native-scroll__wrap h-100", { loading })}>
                        <Scrollbars>
                            <div className="native-scroll__container">
                                {!!data.files?.length && (
                                    <div className="row">
                                        <div className="col-sm-8 offset-sm-2">
                                            <ImageGallery
                                                items={data.files.map((item) => ({
                                                    original: item.accessUrlLink,
                                                    thumbnail: item.accessUrlLink,
                                                }))}
                                            />
                                        </div>
                                    </div>
                                )}
                                <div dangerouslySetInnerHTML={{ __html: data.text }} />
                            </div>
                        </Scrollbars>
                    </div>
                </div>
            </div>
        </Transition>
    );
}

export default viewContainer(ShowNews, "user-platform-news");
